import React, { useState, useEffect } from "react";
import Button from "../Button";
import Input from "../Input";
import { fetchJson } from "../../lib/Fetching";
import MatrixFilter from "../common/form/MatrixFilter";
import SampleInformationFilter from "../common/form/SampleInformationFilter";
import styled, { css } from "styled-components";

const H3 = styled.h3`
  ${(props) =>
    props &&
    props.active &&
    css`
      color: #27c24c;
    `};
`;

export default function NewSampleFromStandaloneQuotes({
  company_id,
  branch_id,
  addToRegistrationList,
  onClose,
}) {
  const [sampleInformation, setSampleInformation] = useState(null);
  const [matrix, setMatrix] = useState(null);
  const [sampleInformations, setSampleInformations] = useState(null);
  const [matrices, setMatrices] = useState(null);
  const [numberOfSamples, setNumberOfSamples] = useState(1);

  useEffect(
    () => {
      if (sampleInformations != null) {
        return;
      }
      fetchSampleInformations();
    },
    [sampleInformations]
  );

  const fetchSampleInformations = () =>
    fetchJson("/products/sample_information.json", {
      company_id: company_id,
      quote_registration: true,
      include_data_fields: true,
    }).then((json) => {
      if (json.error) alert(json.error);
      else setSampleInformations(json);
    });

  useEffect(
    () => {
      if (matrices != null) {
        return;
      }
      fetchMatrices();
    },
    [matrices]
  );

  const fetchMatrices = () =>
    fetchJson("/quotes/matrices_for_standalone_quotes.json", {
      company_id: company_id,
      quote_registration: true,
      include_data_fields: true,
    }).then((json) => {
      if (json.error) alert(json.error);
      else setMatrices(json);
    });

  if (sampleInformations === null || matrices === null) return null;

  if (matrices.length === 0 || sampleInformations.length === 0) {
    return <div>No quotes have been setup for direct registration</div>;
  }

  const canRegister = matrix !== null && sampleInformation !== null && numberOfSamples > 0;

  const addSample = () => {
    if (!canRegister) return;

    addToRegistrationList([
      {
        count: numberOfSamples,
        product: {
          id: -1,
          name: "",
        },
        test_schedule: {
          sample_information_id: sampleInformation.id,
          sample_information_name: sampleInformation.name,
          matrix_id: matrix.id,
        },
      },
    ]);
    onClose();
  };

  const clear = () => {
    setSampleInformation(null);
    setMatrix(null);
    setNumberOfSamples(1);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-4" />
        <div className="col-md-2" style={{ textAlign: "center" }}>
          How many samples?
          <Input
            type="number"
            value={numberOfSamples}
            className="form-control input-lg"
            onChange={(e) => setNumberOfSamples(e.target.value)}
            style={{ marginTop: 10, textAlign: "center" }}
          />
        </div>
        <div className="col-md-2">
          &nbsp;
          <Button
            title={numberOfSamples > 1 ? "Add Samples" : "Add Sample"}
            large
            primary
            block
            icon="fa-plus"
            disabled={!canRegister}
            onClick={addSample}
            className="input-lg"
            style={{ marginTop: 10 }}
          />
        </div>
        <div className="col-md-3" />
      </div>
      <H3 active={!!sampleInformation}>
        <i className={sampleInformation ? "fa fa-check" : "fa fa-times"} />
        &nbsp;
        {sampleInformation ? sampleInformation.name : <span>Select Fields to Use:</span>}
      </H3>
      <div className="panel panel-body">
        <SampleInformationFilter
          sampleInformations={sampleInformations}
          sampleInformation={sampleInformation}
          onChange={(si) => setSampleInformation(si)}
        />
      </div>
      <H3 active={!!matrix}>
        <i className={matrix ? "fa fa-check" : "fa fa-times"} />
        &nbsp;
        {matrix ? matrix.name : <span>Select Matrix of Sample:</span>}
      </H3>
      <div className="panel panel-body">
        <MatrixFilter
          matrices={matrices}
          matrix={matrix}
          onChange={(matrix) => setMatrix(matrix)}
        />
      </div>
    </div>
  );
}
